import { ColorGrid } from '@laranda/lib-sysutil';
import { DameStatusCasos } from '@laranda/lib-ucontrol';
import { Component, OnInit } from '@angular/core';
@Component({
  selector: 'app-inicio',
  templateUrl: './inicio.component.html',
  styleUrls: ['./inicio.component.scss']
})
export class InicioComponent implements OnInit {

  constructor(private dameStatusCasos: DameStatusCasos, private colorGrid: ColorGrid) { }

  ngOnInit() {
    this.dameStatusCasos.consultar();
    this.colorGrid.colorTablaH = '#435499';
  }

}
